import { i18n } from '@/plugins/i18n';
import { Constants } from '@/constants';
import type { DocumentSubmissionFilter, Locales } from '@/services/types/api.types';

const t = i18n.global.t;

const { State, Status } = Constants.ProjectModule.DocumentSubmission;

const stateKeys: Record<DocumentSubmissionFilter, string> = {
  toReview: 'toReview',
  onSite: 'onSite',
  all: 'all',
  [State.Pending]: 'pending',
  [State.Published]: 'published',
  [State.PublishedWithPendingVersion]: 'publishedWithPendingVersion',
  [State.NotPublished]: 'notPublished',
  [State.Withdrawn]: 'withdrawn',
};

const statusKeys: Record<number, string> = {
  [Status.Pending]: 'pending',
  [Status.Approved]: 'approved',
  [Status.Refused]: 'refused',
  [Status.Superseded]: 'superseded',
};

/** A document's state, or a review-list filter, as a translated label; an unknown value as itself. */
export const getStateLabel = (state: string) => {
  const key = stateKeys[state as DocumentSubmissionFilter];
  return key ? t(`project-module.documentSubmission.state.${key}`) : `${state ?? ''}`;
};

/** The locales a document is shown in now that the decision would stop showing it in, in their published order. */
export const getDroppedLocales = (published: Locales[], selected: Locales[]) =>
  published.filter((locale) => !selected.includes(locale));

/** A version's status as a translated label; an unknown value as itself. */
export const getStatusLabel = (status: number) => {
  const key = statusKeys[status];
  return key ? t(`project-module.documentSubmission.status.${key}`) : `${status ?? ''}`;
};
